(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["zw-bewertung-zitat"] && !Shopify.designMode) return;
  try {
    (() => {
    document.addEventListener('click', (event) => {
      const knopf = event.target instanceof Element ? event.target.closest('[data-zw-zitat-mehr]') : null;
      if (!knopf) return;
      const zitat = knopf.closest('.zw-zitat');
      if (!zitat) return;
      const offen = zitat.classList.toggle('zw-zitat--offen');
      const kurz = zitat.querySelector('.zw-zitat__wortlaut--kurz');
      const voll = zitat.querySelector('.zw-zitat__wortlaut--voll');
      if (kurz instanceof HTMLElement) kurz.hidden = offen;
      if (voll instanceof HTMLElement) voll.hidden = !offen;
      knopf.setAttribute('aria-expanded', String(offen));
      knopf.textContent = offen ? 'Weniger' : 'Weiterlesen';
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
